const roundshape = "/media/diamondshapes/shaperound.png";
const ovalshape = "/media/diamondshapes/shapeoval.png";
const princessshape = "/media/diamondshapes/shapeprincess.png";
const pearshape = "/media/diamondshapes/shapepear.png";
const emeraldshape = "/media/diamondshapes/shapeemerald.png";
const cushionshape = "/media/diamondshapes/shapecushion.png";
const heartshape = "/media/diamondshapes/shapeheart.png";
const radiantshape = "/media/diamondshapes/shaperadiant.png";
const marquiseshape = "/media/diamondshapes/shapemarquise.png";
const asschershape = "/media/diamondshapes/shapeasscher.png";

const diamond_Shape = [
    {
        label: "Round",
        icon: roundshape,
        code: "44"
    },
    {
        label: "Oval",
        icon: ovalshape,
        code: "45"
    },
    {
        label: "Princess",
        icon: princessshape,
        code: "46"
    },
    {
        label: "Pear",
        icon: pearshape,
        code: "47"
    },
    {
        label: "Emerald",
        icon: emeraldshape,
        code: "48"
    },
    {
        label: "Cushion",
        icon: cushionshape,
        code: "49"
    },
    {
        label: "Heart",
        icon: heartshape,
        code: "50"
    },
    {
        label: "Radiant",
        icon: radiantshape,
        code: "51"
    },
    {
        label: "Marquise",
        icon: marquiseshape,
        code: "52"
    },
    {
        label: "Asscher",
        icon: asschershape,
        code: "53"
    },
];

export default diamond_Shape;